export class SuccessQuestionRateStat {
  index: number = 0;
  questionLabel: string = '';
  successPercentage: number = 0.0;

  constructor(stats?: Partial<SuccessQuestionRateStat>) {
    Object.assign(this, stats);
  }
}
